import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import DraggableWrapper from "../DraggableWrapper";
import { setClassificationsTabOpen, toggleSuspectViewerOpen } from "../../../../redux/actions/index";
import { Tabs } from "antd";
import UTUFaultNavigation from "./UTUFaultNavigation";
import { SET_SPERRY_MARKERS } from "redux/actions";
import { setTargetInpectionTimestamp } from "../../../../redux/actions/index";

const limits = {
    minWidth: 300,
    minHeight: 490,
    maxWidth: 1000,
    maxHeight: 650,
}; //These need to correspond to the values in the css class draggableWrapper and &__tabContainer!

const SperrySuspectNavigation = ({ id, windowDimensions }) => {
    const dispatch = useDispatch();

    const customDimensionsRef = useRef({ width: 600, height: limits.minHeight });

    const title = (
        <div className="inspectRail__BookmarkList__Title">
            <p>Sperry Suspect Viewer</p>
        </div>
    );

    const closeNavigator = () => {
        dispatch(setClassificationsTabOpen(false));
        dispatch(toggleSuspectViewerOpen());
        dispatch({
            type: SET_SPERRY_MARKERS,
            sperryMarkers: [],
        });
        dispatch(setTargetInpectionTimestamp(null, null));
    };

    const changeActiveTab = (activeKey) => {
        if (activeKey !== "Classifications") {
            dispatch(setClassificationsTabOpen(false));
        }
    };

    const content = (
        <div className="inspectRail__Detections inspectRail__tabContainer">
            <Tabs
                className="draggable-tabs inspectRail__tabContainer"
                defaultActiveKey={"Detections"}
                destroyInactiveTabPane
                onChange={(activeKey) => changeActiveTab(activeKey)}>
                <Tabs.TabPane
                    tab="Sperry Suspect Viewer"
                    key="faults"
                    className="inspectRail__tab inspectRail__tabContent">
                    <UTUFaultNavigation inResizeDraggable />
                </Tabs.TabPane>
            </Tabs>
        </div>
    );

    return (
        <DraggableWrapper
            id={id}
            content={content}
            title={title}
            windowDimensions={windowDimensions}
            closeAction={closeNavigator}
            customDimensionsRef={customDimensionsRef}
            customDimensions={{ width: customDimensionsRef.current.width, height: customDimensionsRef.current.height }}
            limits={limits}
            isResizable
            x={22}
            y={30}
        />
    );
};

export default SperrySuspectNavigation;
